import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["title", "loading", "tables", "reports"],
  _excluded2 = ["href"],
  _excluded3 = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useEffect, useMemo, useState, useCallback } from 'react';
import { Link } from '@Sage/hoi-poi-ui';
import CopilotTable from "../../Table";
import CopilotChart from "../../Chart";
const validLinkAttributes = ['id'];
const CustomLink = _ref => {
  let {
      title,
      loading,
      tables,
      reports
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [parsedData, setParsedData] = useState({
    title: undefined,
    attributes: {}
  });
  const {
      href
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded2);
  const parseTitleString = useCallback(str => {
    try {
      const parsedJson = JSON.parse(str);
      const finalAttributes = Object.entries(parsedJson).reduce((acc, _ref2) => {
        let [key, value] = _ref2;
        if (validLinkAttributes.includes(key)) {
          acc[key] = value;
        }
        return acc;
      }, {});
      setParsedData({
        title: undefined,
        attributes: finalAttributes
      });
    } catch (error) {
      setParsedData({
        title: str,
        attributes: {}
      });
    }
  }, []);
  const {
    Component,
    finalProps
  } = useMemo(() => {
    const {
      attributes,
      title: finalTitle
    } = parsedData;
    if (href !== null && href !== void 0 && href.includes('fm_table')) {
      return {
        Component: CopilotTable,
        finalProps: {
          id: attributes.id,
          loading,
          data: tables[attributes.id] || []
        }
      };
    }
    if (href !== null && href !== void 0 && href.includes('fm_report')) {
      return {
        Component: CopilotChart,
        finalProps: _objectSpread({
          id: attributes.id,
          loading
        }, reports[attributes.id] || {})
      };
    }
    const {
        id
      } = attributes,
      otherAttrs = _objectWithoutProperties(attributes, _excluded3);
    return {
      Component: Link,
      finalProps: _objectSpread(_objectSpread({
        target: '_blank',
        title: finalTitle,
        variation: 'primary'
      }, otherAttrs), {}, {
        href
      }, otherProps)
    };
  }, [parsedData, href, otherProps, loading, tables, reports]);
  useEffect(() => {
    if (title) {
      parseTitleString(title);
    }
  }, [title, parseTitleString]);
  return /*#__PURE__*/React.createElement(Component, finalProps);
};
export default /*#__PURE__*/memo(CustomLink);